import { useEffect } from 'react';
import EVENTS from '@/utils/Constants/Events';
import { useRecipeFilterContext } from '@/context/recipeFilter';

// api
import { paginationResults } from '@/api/get/recipe/facetsAndResults';

export default () => {
  const [{ query, hasLoadMore }] = useRecipeFilterContext();

  useEffect(() => {
    const apiCall = ({ nextPage }) => {
      paginationResults({
        nextPage,
        hasLoadMore,
        query: query.value,
        successCB: html => DLG.EVE.emit(EVENTS.RECIPE.RESULTS.APPEND, { html }),
      });
    };

    DLG.EVE.on(EVENTS.RECIPE.RESULTS.PAGINATION, apiCall);

    return () => {
      DLG.EVE.off(EVENTS.RECIPE.RESULTS.PAGINATION, apiCall);
    };
  }, [query]);
};
